module.exports = __webpack_public_path__ + "img/OBJECTS-2-p-500.c0586c68.png";